import Vue from "vue";
import FixedMenu from "../../components/common/AppFixedMenu";
import MansionSummary from "../../components/pc/MansionSummary";
import mqMixin from "../../mixins/mq";
import dayjs from "dayjs";
Vue.prototype.$dayjs = dayjs;

new Vue({
  el: "#js-rooms-favorites",
  mixins: [mqMixin],
  data: {
    mansions: null,
    clickedSearchSettingButton: false,
    entriesPerPage: [10, 20, 30],
    limit: 10,
    sort: 0,
    sorts: {
      0: "指定なし",
      1: "新着順",
      2: "面積が広い順",
      3: "築年数が浅い順"
    },
    selectedMansions: []
  },
  components: {
    MansionSummary,
    FixedMenu
  },
  computed: {
    showSearchSettingButton() {
      return this.viewMode.sp && !this.clickedSearchSettingButton;
    },
    showRefinementSearch() {
      return this.viewMode.pc || this.clickedSearchSettingButton;
    },
    selectedRoomIds() {
      return this.selectedMansions.flat(1);
    },
    selectedMansionsLength() {
      return this.selectedMansions.filter((m) => {
        return m.length > 0;
      }).length;
    }
  },
  methods: {
    addSelectedMansions(event, ids, index) {
      // console.log(ids);
      // console.log(index);
      this.$set(this.selectedMansions, index, ids);
    },
    changeLimit() {
      const currentURL = new URL(location.href);
      const params = new URLSearchParams(currentURL.search.slice(1));
      params.set("page", 1);
      params.set("limit", this.limit);
      location.href = currentURL.pathname + "?" + params;
    },
    changeSort() {
      const currentURL = new URL(location.href);
      const params = new URLSearchParams(currentURL.search.slice(1));
      params.set("page", 1);
      params.set("sort", this.sort);
      location.href = currentURL.pathname + "?" + params;
    },
    getQueryValue(key) {
      const currentURL = new URL(location.href);
      const params = new URLSearchParams(currentURL.search.slice(1));
      return params.get(key);
    }
  },
  mounted() {
    this.mansions = JSON.parse(this.$el.getAttribute("data-mansions"));

    const limit = parseInt(this.getQueryValue("limit"));
    if (limit && this.entriesPerPage.includes(limit)) {
      this.limit = limit;
    }

    const sort = this.getQueryValue("sort");
    if (sort && Object.keys(this.sorts).includes(sort)) {
      this.sort = sort;
    }
  }
});
